import React, { useEffect, useState } from 'react'
import { validators } from '../../utils/helpers/validators'
import SaveButton from '../common/buttons/SaveButton'
import LabeledText from '../common/form-components/labeled-inputs/LabeledText'
import LabeledNumber from '../common/form-components/labeled-inputs/LabeledNumber'
import LabeledDropdown from '../common/form-components/labeled-dropdown/LabeledDropdown'

import { countries } from '../../data/countries/countries.data'
import { loadSpainLocations } from '../../data/spain/spain-locations.data'
import { useIntl } from 'react-intl'

const PopulationsForm = ({ inputs, handleChange, handleSubmit }) => {
  const { formatMessage: msg } = useIntl()

  const validateForm = validators.hasValue(inputs?.name)
  const [locationsData, setLocationsData] = useState([])
  const [provinceOptions, setProvinceOptions] = useState([])
  const [municipalityOptions, setMunicipalityOptions] = useState([])

  const handleLoadMunicipalities = (e) => {
    const selectedProvince = locationsData.provincias.find(
      (p) => p.nombre === e.value,
    )
    if (selectedProvince) {
      setMunicipalityOptions(
        selectedProvince.municipios.map((m) => ({
          label: m.nombre,
          value: m.nombre,
        })),
      )
    }
    handleChange(e)
  }

  useEffect(() => {
    loadSpainLocations().then((data) => {
      setLocationsData(data)
      setProvinceOptions(
        data.provincias.map((p) => ({
          label: p.nombre,
          value: p.nombre,
        })),
      )
    })
  }, [])

  useEffect(() => {
    if (inputs?.country !== 'ES') {
      setMunicipalityOptions([])
    } else {
      const selectedProvince = locationsData?.provincias?.find(
        (p) => p.nombre === inputs?.province,
      )
      if (selectedProvince) {
        setMunicipalityOptions(
          selectedProvince.municipios.map((m) => ({
            label: m.nombre,
            value: m.nombre,
          })),
        )
      }
    }
  }, [inputs?.country, inputs?.province, locationsData])

  return (
    <div className="general-form-container">
      <div className="modal-content-wrapper">
        <LabeledDropdown
          idLabel="country"
          name="country"
          optionLabel="label"
          optionValue="code"
          value={inputs?.country}
          options={countries}
          showClear
          filter
          onChange={(e) => handleChange(e)}
        />
        {inputs?.country === 'ES' ? (
          <>
            <LabeledDropdown
              idLabel="province"
              name="province"
              optionLabel="label"
              optionValue="value"
              value={inputs?.province}
              options={provinceOptions}
              showClear
              filter
              onChange={(e) => handleLoadMunicipalities(e)}
            />
            <LabeledDropdown
              idLabel="name"
              name="name"
              optionLabel="label"
              optionValue="value"
              value={inputs?.name}
              options={municipalityOptions}
              showClear
              filter
              onChange={(e) => handleChange(e)}
            />
          </>
        ) : (
          <>
            <LabeledText
              idLabel="province"
              required
              name="province"
              value={inputs?.province}
              type="text"
              onChange={(e) => handleChange(e)}
            />
            <LabeledText
              autoFocus
              idLabel="name"
              required
              name="name"
              value={inputs?.name}
              type="text"
              onChange={(e) => handleChange(e)}
            />
          </>
        )}

        <LabeledNumber
          idLabel={msg({ id: 'populations.kmToVic' })}
          name="kmToVic"
          value={inputs?.kmToVic}
          onChange={(e) => handleChange(e)}
          mode="decimal"
          minFractionDigits={0}
          maxFractionDigits={0}
        />
      </div>
      <div className="modal-btn-container">
        <SaveButton
          btnClass="btn-save-modal"
          onClick={() => handleSubmit()}
          isDisabled={!validateForm}
        />
      </div>
    </div>
  )
}

export default PopulationsForm
